<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import {Link} from "@inertiajs/vue3";
import moment from 'moment';

export default {
  components: {Link, App, Card},
  props: ['messages'],
  data() {
    return {
      searchQuery: '',
      selectedTag: '',
      formattedMessages: this.formatMessages(this.messages),
    };
  },
  // Als er ooit tijd is, verbeteren met AJAX call. Moest snel af, dus snelle optie gekozen.
  computed: {
    tags() {
      const allTags = this.messages.flatMap(message => message.tags.map(tag => tag.name));
      return [...new Set(allTags)];
    },
    filteredMessages() {
      return this.formattedMessages.filter(message => {
        const matchesQuery = message.name.includes(this.searchQuery) || message.description.includes(this.searchQuery);
        const matchesTag = this.selectedTag ? message.tags.some(tag => tag.name === this.selectedTag) : true;
        return matchesQuery && matchesTag;
      });
    },
  },
  methods: {
    formatMessages(messages) {
      return messages.map(message => ({
        ...message,
        formattedDate: moment(message.message_datetime).format('DD-MM-YYYY HH:mm:ss'),
      }));
    },
  },
};
</script>

<style scoped>
.card {
  border: 1px solid #ccc;
  border-radius: 8px;
}
.card + .card {
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>

<template>
  <App title="Kennisbank overzicht">
    <Card class="mb-4" v-if="$page.props.auth.permissions.includes('see knowledge_base')">
      <div class="container mt-4">
        <div class="row mb-3">
          <div class="col">
            <input
                type="text"
                class="form-control"
                placeholder="Zoek in de kennisbank..."
                v-model="searchQuery"
            />
          </div>
          <div class="col">
            <select class="form-select" v-model="selectedTag">
              <option value="">Kies een Label</option>
              <option v-for="tag in tags" :key="tag" :value="tag">{{ tag }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div v-for="message in filteredMessages" :key="message.id" class="col-12">
            <div class="card mb-3">
              <div class="card-body">
                <h5 class="card-title">{{ message.name }}</h5>
                <p class="card-text">{{ message.description }}</p>
                <div v-for="image in message.images" :key="image.id" class="card-text mt-2">
                  <img v-if="image.mimetype.startsWith('image')"
                       :src="route('api.v1.assets.preview', { 'asset': image.id})"
                       :alt="image.orig_name"
                       class="img-fluid" />

                  <a v-else-if="image.mimetype === 'application/pdf'"
                     :href="route('api.v1.assets.preview', { 'asset': image.id})"
                     target="_blank">
                    Bekijk Bijlage: {{ image.orig_name }}
                  </a>
                </div>
                <div class="d-flex justify-content-between">
                  <small class="text-muted">{{ message.formattedDate }}</small>
                  <small class="text-muted">
                    <span v-for="(tag, index) in message.tags" :key="tag.id">
                      {{ tag.name }}<span v-if="index < message.tags.length - 1">, </span>
                    </span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </App>
</template>

